import Layout from "components/layout";
import { ReactNode } from "react";
import { useAnnouncementList } from "features/annoucements/hooks/useAnnouncementList";
import { List } from "shared/components/molecules/List";
import { Loading } from "shared/components/templates/Loading";
import tw from "twin.macro";
import { AnnouncementListItem } from "features/annoucements/components/AnnouncementListItem";

const AnnouncementList = () => {
  const { announcements, isValidating, isLoadingMore } = useAnnouncementList();

  return (
    <>
      <List
        tw="border-none"
        data={announcements}
        renderItem={(announcement) => (
          <AnnouncementListItem announcement={announcement} />
        )}
      />
      {isValidating && (
        <Loading loading css={isLoadingMore && tw`bg-[transparent]`} />
      )}
    </>
  );
};

AnnouncementList.getLayout = (page: ReactNode) => {
  return <Layout footer={null}>{page}</Layout>;
};

export default AnnouncementList;
